import { createSelector, createSlice } from "@reduxjs/toolkit";
import { teams as initialState } from "../initialState";
import { selectTeamByIdSelector } from "../selectors/teamsSelectors";
import updateTeamsAction from "../actions/teamActions";

export const slice = createSlice({
    name: "teams",
    initialState,
    reducers: {
        setTeams: (state, action) => action.payload,
        updateTeams: (state, action) => updateTeamsAction(state, action),
        replaceTeamsState: (state, action) => action.payload,
        removeNewTeamFromTeams: (state) => {
            const newTeams = [...state].filter(
                (team) => team.id !== "new-team",
            );
            return newTeams;
        },
    },
});

// actions
export const {
    setTeams,
    updateTeams,
    replaceTeamsState,
    removeNewTeamFromTeams,
} = slice.actions;

// selectors

// Same as getTeams
export const selectTeams = (state) => state.teams;

export const selectTeamById = createSelector(
    [(state) => selectTeams(state), (state, teamId) => teamId],
    (teams, teamId) => selectTeamByIdSelector(teams, teamId),
);

export default slice.reducer;
